import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '@/utils/cn';

type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  hasError?: boolean;
};

/**
 * Sizilianer Multi-Line-Textarea.
 * Min-Height 96px, vertikales Resize erlaubt.
 *
 * @example
 *   <Textarea
 *     placeholder="Sonderwünsche oder Anlass…"
 *     rows={4}
 *     maxLength={500}
 *   />
 */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  function Textarea({ hasError, className, rows = 4, ...props }, ref) {
    return (
      <textarea
        ref={ref}
        rows={rows}
        className={cn(
          'w-full rounded-md',
          'bg-paper-2 text-ink-2 placeholder:text-ink-mute',
          'font-sans text-base leading-relaxed',
          'min-h-24 px-3.5 py-3 resize-y',
          hasError
            ? 'border border-it-red focus:outline-2 focus:outline-it-red'
            : 'border border-rule focus:border-gold focus:outline-2 focus:outline-gold/40 focus:outline-offset-1',
          'disabled:opacity-50 disabled:cursor-not-allowed',
          'transition-colors',
          className,
        )}
        {...props}
      />
    );
  },
);
